import { render, staticRenderFns } from "./table8.vue?vue&type=template&id=5a1b30cd&scoped=true&"
import script from "./table8.vue?vue&type=script&lang=js&"
export * from "./table8.vue?vue&type=script&lang=js&"
import style0 from "./table8.vue?vue&type=style&index=0&id=5a1b30cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1b30cd",
  null
  
)

export default component.exports